import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Car, Email, FilePlusMinus, PDF, Right } from '../../../components/Icon';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { InvoiceStatus } from './InvoiceStatus';
import {
  downloadInvoicePDF,
  emailInvoice,
  downloadInvoicePurchase,
  downloadInvoiceTradeIn,
  getInvoiceTradeInVehicles,
} from '../actions';
import { selectWork } from '../../Api/selectors';
import { EditSquare } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { WithCompany } from '../../Companies/components/WithCompany';
import { selectCompany } from '../../Companies/selectors';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { UserLabelById } from '../../Users/components/UserLabelById';
import { UserSelection } from '../../Users/components/UserSelection';
import { VehicleCreateFieldCompanyUser } from '../../Vehicles/pages/create/FieldCompanyUser';
import { InvoiceEmailStatus } from './InvoiceEmailStatus';
import { getPropByName } from '../../../utils/props';
import { FormField } from '../../../components/FormFields';
import { FormControl, Input } from '../../../components/Input';
import { Checkbox } from '../../../components/Checkbox';
import { Well } from '../../../components/Well';
import { fetchUser, fetchUsers } from '../../Users/actions';
import { selectUser } from '../../Users/selectors';
import {
  INVOICE_DIRECTIONS,
  REQUEST_INVOICE_DOWNLOAD,
  REQUEST_INVOICE_EMAIL,
  REQUEST_INVOICE_TRADE_IN_VEHICLES,
} from '../constants';
import { REQUEST_COMPANY } from '../../Companies/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import env from '../../../env.js';
import { AppClientId } from '../../Shared/constants.js';
import styles from './InvoiceListItem.module.css';
import ModalComponent from '../../../containers/App/Components/Modal/Modal.js';
import ButtonComponent from '../../../containers/App/Components/Button/Button.js';

const Wrapper = styled.div`
  margin: 12px auto 0;
  width: 100%;
  max-width: 750px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  background-color: white;
  border-radius: 12px;
`;

const Record = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 50%;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

const STATE = {
  email: false,
  target_email_address: '',
  target_email_address_set: false,
  financialContact: null,
  emailContact: null,
  emailTo: '',
};

class InvoiceListItemComp extends BaseComponent {
  tofn(url) {
    return event => {
      event.preventDefault(); // Prevent default behavior to avoid duplicate actions
      event.stopPropagation(); // Stop propagation if needed to prevent other handlers

      // Check for ctrlKey (Windows) or metaKey (Mac) for new tab
      const newWindow = event.ctrlKey || event.metaKey;
      this.to(url, newWindow);
    };
  }
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.financialContactId &&
      this.props.fetchUser(this.props.financialContactId, res => {
        if (res?.id) {
          this.setState({
            financialContact: res,
            isShow_financialContact: '1',
          });
        }
      });
    this.props.emailContactId &&
      this.props.fetchUser(this.props.emailContactId, res => {
        if (res?.id) {
          this.setState({
            emailContact: res,
            isShow_emailContact: '1',
          });
        }
      });
    this.props.invoice?.emailTo &&
      this.setState({
        emailTo: this.props.invoice?.emailTo,
        isShow_emailTo: '1',
      });

    this.props.fetchTradeInVehicles(result => {
      if (result?.length) {
        this.setState({
          tradeIn: true,
        });
      }
    });

    if ((env.clientId === AppClientId.AUTOWIENTJES || env.clientId === AppClientId.AUTOHUISSALLAND) && !this.state.emailTo) {
      this.setState({
        emailTo: getPropByName(this.props.outgoingCompany, 'company_email'),
        isShow_emailTo: '1',
      });
      return;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.financialContactId && !this.state.financialContact) {
      this.props.fetchUser(this.props.financialContactId, res => {
        if (res?.id) {
          this.setState({
            financialContact: res,
            isShow_financialContact: '1',
          });
        }
      });
    }

    if (this.props.emailContactId && !this.state.emailContact) {
      this.props.fetchUser(this.props.emailContactId, res => {
        if (res?.id) {
          this.setState({
            emailContact: res,
            isShow_emailContact: '1',
          });
        }
      });
    }

    if (this.props.invoice?.emailTo && !this.state.emailTo) {
      this.setState({
        emailTo: this.props.invoice?.emailTo,
        isShow_emailTo: '1',
      });
    }
  }

  get invoiceId() {
    return this.props.invoice.id;
  }

  get entryNumber() {
    return this.props.invoice?.entryNumber;
  }

  get invoiceDate() {
    const date = this.props.invoice.date;
    return this.formatDate(date);
  }

  get invoiceDueDate() {
    const date = this.props.invoice.dueDate;
    return this.formatDate(date);
  }

  get direction() {
    return this.props.invoice.direction;
  }

  get isFinal() {
    return this.props.invoice.isFinal ? 'FINAL' : 'NOT FINAL';
  }

  get invoiceStatus() {
    return this.props.invoice?.status?.name ?? 'OPEN';
  }

  get relation() {
    return this.props.invoice.relation;
  }

  get financialTotalAmount() {
    const EURFormat = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format;
    if (!this.props.invoice.financialTotalAmount) return null;

    return EURFormat(this.props.invoice.financialTotalAmount);
  }

  get description() {
    return this.props.invoice.description;
  }

  get subjectType() {
    return this.props.invoice?.subjectType?.toUpperCase();
  }

  get type() {
    return this.props.invoice?.type?.toUpperCase() ?? 'INVOICE';
  }

  get userCreatorEmail() {
    return this.props.user?.email_address;
  }

  get financialContact() {
    return this.props.financialContactId?.email_address;
  }

  get outgoingUser() {
    return this.props.outgoingUserId?.email_address;
  }

  get emailContact() {
    return this.props.emailContactId?.email_address;
  }

  get emailTo() {
    return this.props.invoice?.emailTo;
  }

  get selectedEmails() {
    let emails = [];
    ['financialContact', 'emailContact', 'emailTo'].map(type => {
      if (type === 'emailTo' && this.state.emailTo && this.state[`isShow_${type}`] == '1') {
        return emails.push({ email: this.state.emailTo });
      }
      if (this.state[type]?.email_address && this.state[`isShow_${type}`] == '1') {
        let emailAddressProp = null;
        if (this.state[type]) {
          emailAddressProp = getPropByName(this.state[type], 'email_address');
        }
        const emailToSend = emailAddressProp || this.state[type]?.email_address;
        emails.push({ email: emailToSend });
      }
    });

    return emails;
  }

  onChangeUser(userId, type) {
    this.props.fetchUser(userId, result => {
      if (result?.id) {
        this.setState({ [type]: result, selectUser: false, addUser: null });
      }
    });
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;
    return (
      <ModalComponent title={this.lbl('company.users.delete.confirm.title')}>
        {this.state.addUser?.id ? (
          <VBox>{this.state.addUser?.email_address}</VBox>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}

        <div className="d-flex gap-2 mt-2">
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            disabled={!this.state.addUser?.id}
            onClick={() => this.onChangeUser(this.state.addUser?.id, 'emailContact')}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.setState({ selectUser: false, addUser: null })}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  formatDate(dateString) {
    if (!dateString) return '-';
    return dayjs(dateString).format('DD-MM-YYYY');
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.target_email_address_set && state.target_email_address == STATE.target_email_address && props.targetCompany) {
      //email should be sent to mail address
      state.target_email_address_set = true;
      let invoice_to_main_address = getPropByName(props.targetCompany, 'invoice_to_main_address');
      if (invoice_to_main_address === '1') state.target_email_address = getPropByName(props.targetCompany, 'company_email');
      else {
        //email goes to financial contact
        let financial_contact = props.targetCompany.users?.find(
          user => user.id == getPropByName(props.targetCompany, 'relation_financial_contact_id'),
        );

        if (financial_contact) {
          //finacial contact is found
          state.target_email_address = getPropByName(financial_contact, 'email_address');
        }
      }
    }
    return state;
  }

  renderCard = vehicleId => (
    <Wrapper key={this.invoiceId} onClick={this.props.onClick}>
      {/* {this.state.email ? (
        <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('email')}>
          {this.renderEmailModal()}
        </ModalComponent>
      ) : null} */}
      <HBox vCenter>
        <div style={{ fontWeight: 'bold' }}>
          <span style={{ marginRight: '10px' }}>
            <span style={{ color: '#aaa', fontWeight: '100' }}>{this.invoiceId}</span>
            <span>{this.entryNumber ? ` / ${this.entryNumber} ` : ''}</span>
          </span>
          <span>{this.description ?? '-'}</span>
        </div>
      </HBox>
      <HBox vCenter style={{ gap: 10 }} flip={window.innerWidth <= 500}>
        <Record>
          <strong>Direction: </strong>
          <span>{this.direction}</span>
        </Record>
        <Record>
          <strong>Relation: </strong>
          <span>{this.relation ?? '-'}</span>
        </Record>
      </HBox>
      <HBox vCenter style={{ gap: 10 }} flip={window.innerWidth <= 500}>
        <Record>
          <strong>Total: </strong>
          <span>{this.financialTotalAmount ?? '-'}</span>
        </Record>
        <Record>
          <strong>Date: </strong>
          <span>{this.invoiceDate}</span>
        </Record>
      </HBox>
      <HBox vCenter left style={{ gap: 10 }} flip={window.innerWidth <= 900}>
        <HBox vCenter left style={{ gap: 10, flexWrap: 'wrap' }}>
          {this.type && <InvoiceStatus status={this.type} />}
          {this.subjectType && <InvoiceStatus status={this.subjectType} />}
          <InvoiceStatus status={this.invoiceStatus} />
          <InvoiceStatus status={this.isFinal} />
        </HBox>
        <HBox vCenter right={window.innerWidth > 900} center={window.innerWidth <= 900} style={{ gap: 5 }}>
          {vehicleId && (
            <div style={{ cursor: 'pointer', width: '50px' }} onClick={this.tofn(`/vehicles/${vehicleId}`)}>
              <Car />
            </div>
          )}
          <div style={{ width: '50px' }}>
            {this.props.downloading ? (
              <Loader small />
            ) : (
              <div
                onClick={evt => {
                  evt.stopPropagation();
                  this.props.download();
                }}
                style={{ cursor: 'pointer' }}
              >
                <PDF />
              </div>
            )}
          </div>
          <div
            style={{ cursor: 'pointer', width: '50px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.setState({ email: true });
            }}
          >
            <HBox>
              {this.props.sending ? <Loader small /> : <Email />}
              <InvoiceEmailStatus vehicleId={vehicleId} invoice={this.props.invoice} />
            </HBox>
          </div>
        </HBox>
      </HBox>
    </Wrapper>
  );

  isPurchaseStatement = () => {
    const isMargin =
      this.props.invoice?.invoiceSubjects?.find(s => s.type === 'vehicle' && s?.btwOrMarge === 'marge') ?? false;
    const isIndividualCompany =
      this.props.invoice?.incomingCompany?.properties?.find(p => p?.name?.name === 'company_type')?.value === 'individual';
    return (
      this.props.invoice.direction === 'incoming' &&
      this.props.invoice.subjectType === 'vehicle' &&
      isMargin &&
      isIndividualCompany
    );
  };

  renderIcons = vehicleId => {
    // console.log(this.state, 'STATE_____');
    let showPSIcon = this.isPurchaseStatement();
    return (
      <>
        <HBox
          className={this.props.className}
          vCenter
          right={window.innerWidth > 900}
          center={window.innerWidth <= 900}
          style={{ gap: 10 }}
        >
          {vehicleId && (
            <div style={{ cursor: 'pointer', width: '50px' }} onClick={this.tofn(`/vehicles/${vehicleId}`)}>
              <Car />
            </div>
          )}
          <div
            style={{ cursor: 'pointer', width: '30px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.setState({ email: true });
            }}
          >
            <HBox>
              {this.props.sending ? <Loader small /> : <Email />}
              <InvoiceEmailStatus vehicleId={vehicleId} invoice={this.props.invoice} />
            </HBox>
          </div>
          <div className={styles.iconContainer}>
            {this.props.downloading ? (
              <Loader small />
            ) : (
              <div
                onClick={evt => {
                  evt.stopPropagation();
                  this.props.download();
                }}
                style={{ cursor: 'pointer' }}
              >
                <PDF />
              </div>
            )}
          </div>
          {!!showPSIcon && (
            <div className={styles.iconContainer}>
              {this.props.downloadingPS ? (
                <Loader small />
              ) : (
                <div
                  onClick={evt => {
                    evt.stopPropagation();
                    this.props.downloadPurchase();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faFileSignature} />
                </div>
              )}
            </div>
          )}
          <div className={styles.iconContainer}>
            {this.props.downloadingTrIn || this.props.tradeInWork ? (
              <Loader small />
            ) : (
              this.state.tradeIn && (
                <div
                  onClick={evt => {
                    evt.stopPropagation();
                    this.props.downloadTradeIn();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faFileExport} />
                </div>
              )
            )}
          </div>
        </HBox>
      </>
    );
  };

  render() {
    let vehicleId =
      this.props.invoice?.vehicle?.id ?? this.props.invoice.invoiceSubjects?.find(subject => subject.vehicleId)?.vehicleId;

    return (
      <>
        {this.state.email ? (
          <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('email')}>
            {this.renderEmailModal()}
          </ModalComponent>
        ) : null}
        {this.renderIcons(vehicleId)}
      </>
    );
  }

  renderEmailModal() {
    if (this.props.invoice.direction === INVOICE_DIRECTIONS.INCOMING && (this.props.busy || this.props.sending))
      return <Loader />;
    const targetCompanyId =
      this.props.invoice.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice.outgoingCompanyId
        : this.props.invoice.incomingCompanyId;

    if (!targetCompanyId) return <Well alert>{this.lbl('invoice.item.warning.no_target_company')}</Well>;

    return (
      <div style={{ color: 'black' }}>
        <WithCompany companyId={targetCompanyId} loader>
          <Well>
            <CompanyLabel company={this.props.targetCompany} withSurname={true} />
          </Well>
          {this.renderAddUser()}
          {this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING && (
            <>
              {['financialContact', 'emailContact'].map(type => {
                if (type == 'emailContact' && this.state) {
                  return (
                    <VBox key={type} left vCenter style={{ marginBottom: '15px' }}>
                      <span style={{ fontWeight: '400' }}>{this.lbl(`vehicle.order.property.send_to_email`)}</span>
                      <VBox left>
                        <HBox vCenter style={{ marginBottom: '24px ' }}>
                          <Checkbox
                            checked={this.state[`isShow_${type}`] === '1'}
                            onChange={() => {
                              this.state[`isShow_${type}`] == '1'
                                ? this.setState({ [`isShow_${type}`]: '0' })
                                : this.setState({ [`isShow_${type}`]: '1' });
                            }}
                          />
                          {this.state.emailContact?.id ? (
                            <UserLabelById
                              order
                              user_id={this.state.emailContact?.id}
                              key={this.state.emailContact?.id}
                              inputLabel
                            />
                          ) : (
                            <input disabled className="form-control" style={{ width: '100%' }} value={''} />
                          )}
                          <ButtonComponent
                            style={'ButtonSoftEdit'}
                            disabled={this.state[`isShow_${type}`] !== '1'}
                            small
                            onClick={() => this.setState({ selectUser: true })}
                          >
                            <EditSquare />
                          </ButtonComponent>
                        </HBox>
                      </VBox>
                    </VBox>
                  );
                }
                return (
                  type === 'financialContact' &&
                  this.state && (
                    <VBox left>
                      <span style={{ fontWeight: '400' }}>{this.lbl('vehicle.order.property.financial_contact')}</span>
                      <HBox style={{ marginBottom: '15px' }}>
                        <FormField>
                          <Checkbox
                            checked={this.state[`isShow_${type}`] === '1'}
                            onChange={() => {
                              this.state[`isShow_${type}`] == '1'
                                ? this.setState({ [`isShow_${type}`]: '0' })
                                : this.setState({ [`isShow_${type}`]: '1' });
                            }}
                          ></Checkbox>
                          <VehicleCreateFieldCompanyUser
                            financialContact={true}
                            includeFinancialContact={this.state[`isShow_${type}`] === '1' ? '1' : '0'}
                            selectedCreditorId={this.state.financialContact?.id}
                            title={type}
                            companyId={targetCompanyId}
                            key={`${type}-${targetCompanyId}`}
                            type={type}
                            onChange={value => this.onChangeUser(value, type)}
                          />
                        </FormField>
                      </HBox>
                    </VBox>
                  )
                );
              })}
              <HBox left>
                <Checkbox
                  checked={this.state['isShow_emailTo'] === '1'}
                  onChange={evt =>
                    this.state['isShow_emailTo'] == '1'
                      ? this.setState({ ['isShow_emailTo']: '0' })
                      : this.setState({ ['isShow_emailTo']: '1' })
                  }
                />

                <input
                  className="form-control"
                  disabled={this.state['isShow_emailTo'] != '1'}
                  type="email"
                  style={{ width: '80%' }}
                  value={this.state.emailTo}
                  onChange={evt => {
                    this.setState({ emailTo: evt.target.value });
                  }}
                />
              </HBox>
            </>
          )}

          {this.props.invoice?.direction !== INVOICE_DIRECTIONS.OUTGOING && (
            <FormField label={this.lbl('invoice.item.target_email_address')}>
              <Input
                full
                name="target_email_address"
                onChange={this.onInputChange.bind(this)}
                value={this.state.target_email_address}
              />
            </FormField>
          )}
          <ModalControls>
            <ButtonComponent
              style={'ButtonSoftPrimaryFullWidth'}
              disabled={
                this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
                  ? !this.selectedEmails.length
                  : !this.state.target_email_address
              }
              onClick={() => {
                this.props.email(
                  this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
                    ? this.selectedEmails
                    : [{ email: this.state.target_email_address }],
                  () => {
                    this.reset();
                  },
                );
              }}
            >
              {this.lbl('send')}
            </ButtonComponent>
          </ModalControls>
        </WithCompany>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    downloading: selectWork(`${REQUEST_INVOICE_DOWNLOAD}-${ownProps.invoice.id}`),
    downloadingPS: selectWork(`${REQUEST_INVOICE_DOWNLOAD}-${ownProps.invoice.id}-ps`),
    downloadingTrIn: selectWork(`${REQUEST_INVOICE_DOWNLOAD}-${ownProps.invoice.id}-trIn`),
    busy: selectWork(REQUEST_COMPANY),
    sending: selectWork(`${REQUEST_INVOICE_EMAIL}-${ownProps.invoice.id}`),
    tradeInWork: selectWork(`${REQUEST_INVOICE_TRADE_IN_VEHICLES + ownProps.invoice.id}`),
    targetCompany: selectCompany(
      ownProps.invoice.direction == INVOICE_DIRECTIONS.OUTGOING
        ? ownProps.invoice.outgoingCompanyId
        : ownProps.invoice.incomingCompanyId,
    ),
    user: selectUser(ownProps?.userCreatorId),
    financialContact: selectUser(ownProps?.financialContactId),
    outgoingUser: selectUser(ownProps?.outgoingUserId),
    emailContact: selectUser(ownProps?.emailContactId),
    outgoingCompany: selectCompany(ownProps.invoice?.outgoingCompanyId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
    fetchTradeInVehicles(callback) {
      dispatch(getInvoiceTradeInVehicles(ownProps.invoice.id, callback));
    },
    email(address, callback) {
      dispatch(emailInvoice(ownProps.invoice.id, address, callback));
    },
    download() {
      dispatch(
        downloadInvoicePDF(ownProps.invoice.id, result => {
          var blob = new Blob([new Uint8Array(result.file.data)], { type: 'application/pdf' });
          var objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        }),
      );
    },
    downloadPurchase() {
      dispatch(
        downloadInvoicePurchase(ownProps.invoice.id, result => {
          var blob = new Blob([new Uint8Array(result.file.data)], { type: 'application/pdf' });
          var objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        }),
      );
    },
    downloadTradeIn() {
      dispatch(
        downloadInvoiceTradeIn(ownProps.invoice.id, result => {
          var blob = new Blob([new Uint8Array(result.file.data)], { type: 'application/pdf' });
          var objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceListItem = compose(withConnect, withRouter)(InvoiceListItemComp);
